
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateCronFilterForm from '@/services/QA/cron-settings/forms/CreateCronFilterForm';
import { CronFilterInterface, CronSettingsRepositoryInterface } from '@/services/QA/cron-settings/interfaces';

@Component({
  inject: [
    'cronSettingsRepository',
  ],
})
export default class EditSettings extends Vue {
  private form: WPXFormValue<CreateCronFilterForm> = new WPXFormValue(CreateCronFilterForm);
  private cronSettingsRepository!: CronSettingsRepositoryInterface;
  private loading: boolean = true;
  private filter!: CronFilterInterface;

  private properties: Array<{ key: string, value: string }> = [
    { key: 'Client ID', value: 'client_id' },
    { key: 'Client Name', value: 'name' },
    { key: 'Client Email', value: 'email' },
    { key: 'Ticket Status', value: 'status' },
    { key: 'Department', value: 'department' },
  ];

  private async created(): Promise<void> {
    const filter = await this.cronSettingsRepository.getFilterById(Number(this.$route.params.id));
    this.filter = filter;
    this.form.data.property = filter.property;
    this.form.data.value = filter.value;
    this.loading = false;
  }

  private async editFilter(): Promise<void> {
    try {
      await this.cronSettingsRepository.editCronFilter(this.filter.id, {
        property: this.form.data.property,
        value: this.form.data.value,
      });

      this.$successDialog.show('Filter Created Successfully');
      await this.$router.push({ name: 'all_cron_settings' });
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message);
    }
  }
}
